import {
  Activity,
  Bike,
  Calendar,
  Coffee,
  Dumbbell,
  FileText,
  Footprints,
  PersonStanding,
  Snowflake,
  Waves,
} from 'lucide-react'
import { getBaseActivityType } from './activities'

export const ENTRY_ICONS = {
  swim: Waves,
  swimming: Waves,
  bike: Bike,
  cycling: Bike,
  hiking: Footprints,
  cross_country_skiing: Snowflake,
  run: Footprints,
  running: Footprints,
  strength: Dumbbell,
  mobility: PersonStanding,
  recovery: Coffee,
  rest_day: Coffee,
  note: FileText,
  event: Calendar,
  other: Activity,
} as const

export type DisciplineIconType = keyof typeof ENTRY_ICONS

export const getEntryIcon = (entryType?: string) => {
  const icon = ENTRY_ICONS[entryType as DisciplineIconType]
  if (icon) return icon

  const baseActivityType = getBaseActivityType(entryType || '')
  const baseActivityIcon = ENTRY_ICONS[baseActivityType as DisciplineIconType]
  return baseActivityIcon || Activity
}
